import React, { useEffect, useState } from 'react';
import { trashService } from '../services/api';
import styles from './Trash.module.css';

function formatDate(str) {
    if (!str) return '—';
    return new Date(str).toLocaleDateString('ar-SY', { year: 'numeric', month: 'short', day: 'numeric' });
}

export default function Trash() {
    const [items,   setItems]   = useState([]);
    const [loading, setLoading] = useState(true);
    const [reasons, setReasons] = useState({});
    const [busy,    setBusy]    = useState({});

    useEffect(() => {
        trashService.list()
            .then((r) => {
                const data = Array.isArray(r.data) ? r.data : (r.data.data ?? []);
                setItems(data);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, []);

    const handleRestore = async (id) => {
        setBusy((b) => ({ ...b, [id]: true }));
        try {
            await trashService.restore(id);
            setItems((prev) => prev.filter((p) => p.id !== id));
        } catch {
            alert('فشل الاستعادة');
        } finally {
            setBusy((b) => ({ ...b, [id]: false }));
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm('حذف نهائي؟ لا يمكن التراجع عن هذا الإجراء.')) return;
        setBusy((b) => ({ ...b, [id]: true }));
        try {
            await trashService.permanentDelete(id, reasons[id] || '');
            setItems((prev) => prev.filter((p) => p.id !== id));
        } catch {
            alert('فشل الحذف النهائي');
        } finally {
            setBusy((b) => ({ ...b, [id]: false }));
        }
    };

    if (loading) return <div className={`${styles.state} text-ar`}>جاري التحميل...</div>;

    return (
        <div className={`${styles.page} text-ar`}>
            <div className={styles.pageHeader}>
                <h1>سلة المحذوفات</h1>
                <span className={styles.count}>{items.length} احتجاج محذوف</span>
            </div>

            {items.length === 0 ? (
                <div className={styles.empty}>سلة المحذوفات فارغة</div>
            ) : (
                <div className={styles.list}>
                    {items.map((p) => (
                        <div key={p.id} className={styles.item}>
                            <div className={styles.itemInfo}>
                                <div className={styles.itemTitle}>
                                    {p.governorate?.name
                                        ? p.region?.name
                                            ? `${p.governorate.name} - ${p.region.name}`
                                            : p.governorate.name
                                        : p.region?.name || 'غير محدد'}
                                </div>
                                <div className={styles.itemMeta}>
                                    <span>تاريخ الاحتجاج: {formatDate(p.protest_date)}</span>
                                    <span>حُذف: {formatDate(p.deleted_at)}</span>
                                    {p.user && <span>أُدخل بواسطة: {p.user.name}</span>}
                                    {p.protest_type && <span>{p.protest_type}</span>}
                                </div>
                                {p.demands && (
                                    <p className={styles.demands}>{p.demands}</p>
                                )}
                            </div>
                            <div className={styles.itemActions}>
                                <input
                                    className={styles.reasonInput}
                                    placeholder="سبب الحذف النهائي (اختياري)"
                                    value={reasons[p.id] || ''}
                                    onChange={(e) => setReasons((r) => ({ ...r, [p.id]: e.target.value }))}
                                />
                                <div className={styles.btnRow}>
                                    <button
                                        className={styles.restoreBtn}
                                        onClick={() => handleRestore(p.id)}
                                        disabled={busy[p.id]}
                                    >
                                        {busy[p.id] ? '...' : '↩ استعادة'}
                                    </button>
                                    <button
                                        className={styles.deleteBtn}
                                        onClick={() => handleDelete(p.id)}
                                        disabled={busy[p.id]}
                                    >
                                        {busy[p.id] ? '...' : '🗑 حذف نهائي'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
